<template>
  <v-container>
    <v-btn class="ml-8" color="secondary" to="/admin/kegiatan/list">
      <v-icon left> mdi-arrow-left </v-icon>
      Kembali
    </v-btn>
    <form class="pa-4" v-on:keyup.enter="submit">
      <v-card flat outlined class="ma-4">
        <v-toolbar flat color="primary white--text">
          <v-toolbar-title>Tambahkan Anggota Kegiatan</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-row>
            <v-col>
              <v-text-field
                outlined
                v-model="program"
                label="Nama Kegiatan"
                readonly
              ></v-text-field>
            </v-col>
            <v-col>
              <v-text-field
                outlined
                label="Nama Anggota"
                :error-messages="nameError"
                :value="jamaah.name | capitalize"
                @input="value => jamaah.name = value"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row no-gutters class="mt-0">
            <v-col class="mr-6">
              <v-menu 
              :close-on-content-click="false" 
              max-width="290"
              v-model="menu">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    :value="jamaah.birthdate"
                    outlined
                    clearable
                    label="Tanggal Lahir"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    @click:clear="jamaah.birthdate = null"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="jamaah.birthdate"
                  no-title
                  @change="menu = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col>
              <v-text-field
                outlined
                v-model="phone_number"
                label="Nomor HP"
                prefix="+62"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row no-gutters class="mt-0">
            <v-col class="mr-6">
              <v-text-field
                outlined
                v-model.trim="$v.jamaah.address.$model"
                label="Alamat"
                :error-messages="addressError"
              ></v-text-field>
            </v-col>
            <v-col>
              <v-text-field
                outlined
                v-model="jamaah.additional_info.note"
                label="Catatan"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <v-btn @click="submit" color="primary" class="ml-4">
        Submit!
        <v-progress-circular
          v-if="this.isSubmitLoading == true"
          class="ml-2"
          indeterminate
          color="secondary"
          size="16"
          width="2"
        ></v-progress-circular>
      </v-btn>
      <v-dialog v-model="dialog" max-width="290">
        <v-card>
          <v-card-title class="headline"> Info </v-card-title>

          <v-card-text>
            Submit sukses!
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="green darken-1" text @click="dialog = false" :to="`/admin/kegiatan/listMember/${masjid_program_uid}`">
              OK
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <p v-if="isFormError" class="mt-2 red--text text-caption error-caption">
        "Manusia memang sering melakukan kesalahan, tapi yang terpenting adalah
        bagaimana kita memperbaikinya" <br />
        -Admin
      </p>
    </form>
  </v-container>
</template>
<script>
import { required } from "vuelidate/lib/validators";

export default {
  props: ["masjid_program_uid"],
  data(){
    return{
      phone_number: "",
      menu: false,
      program: "",
      isSubmitLoading: false,
      dialog: false,
      jamaah: {
        masjid_program_uid: "",
        masjid_uid: localStorage.getItem("masjid"),
        name: "",
        address: "",
        birthdate: "",
        phone_number: "",
        additional_info: {}
      },
      isFormError: false
    }
  },
  filters: {
    capitalize: function (value) {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    }
  },
  validations: {
    jamaah: {
      name: {
        required
      },
      address: {
        required
      }
    }
  },
  computed: {
    nameError() {
      const errors = [];
      if (!this.$v.jamaah.name.$dirty) return errors;
      !this.$v.jamaah.name.required && errors.push("Nama tidak boleh kosong");
      return errors;
    },
    addressError() {
      const errors = [];
      if (!this.$v.jamaah.address.$dirty) return errors;
      !this.$v.jamaah.address.required && errors.push("Alamat tidak boleh kosong");
      return errors;
    },
  },
  created() {
    this.jamaah.masjid_program_uid = this.masjid_program_uid

    this.programDetail()
  },
  methods: {
    programDetail() {
      this.axios(`/program/detail/${this.masjid_program_uid}`)
      .then(res => {
        console.log(res, 'response fetch detail program')
        this.program = res.data.data.name
      })
      .catch(err => {
        console.log(err, 'error fetch detail program')
      })
    },
    submit() {
      this.isSubmitLoading = true
      this.$v.$touch()
      let phonePrefix = ""
      if(this.phone_number) {
        phonePrefix = '62' + this.phone_number
      }
      this.jamaah.phone_number = phonePrefix
      console.log(this.jamaah.phone_number)

      if(this.$v.jamaah.$invalid) {
        this.isFormError = true
        this.isSubmitLoading = false
      }else{
        this.axios.post("/program/jamaah", this.jamaah)
        .then(res => {
          console.log(res, "response post jamaah program")
          this.isSubmitLoading = false
          if(res.data.status == true) {
            this.isFormError = false
            this.dialog = true
          }
        })
        .catch(err => {
          console.log(err, "error post jamaah program")
          this.isSubmitLoading = false
        })
      }
    }
  }
};
</script>
